import wsData from './wsdata_h5'
import urls from './config'
console.log('env:', urls.env, '; NODE_ENV:', process.env.NODE_ENV)
let env = process.env.NODE_ENV == 'development' ? `-${process.env.VUE_APP_CURRENTMODE}` : urls.env
const initPara = {
  name: 'wsdata',
  server_url: process.env.NODE_ENV == 'development' ? '/ws_api/batchUpload': `https://wseventtrack${urls.env}.wsecar.com/api/batchUpload`,
  show_log: process.env.NODE_ENV == 'development' || urls.env != '' ? true : false,
  debug_mode: false,
  encrypt_cookie: false,
  debug_mode_url: `https://buriedpoint${env}.wsecar.com/api/eventTrackManagerImpl/other/checkData`,
  preset_properties: {
    app_name: '4'
  }
}

export const wsDataInit = function(para = initPara) {
  var n = para.name,
    w = window,
    d = document;
    
  if (typeof (w['wsDataStorage']) !== 'undefined') {
    return false;
  }
  w['wsDataStorage'] = n;
  w[n] = w[n] || function (a) {
    return function () {
      (w[n]._q = w[n]._q || []).push([a, arguments]);
    };
  };
  var ifs = ['track', 'quick', 'register', 'login'];
  ifs.forEach(obj => {
    w[n][obj] = w[n].call(null, obj);
  })
  if (!w[n]._t) {
    w[n].para = para;
    wsData.init()
  }
}